import isNil from 'lodash/isNil';

import { AJSResponse } from '@qality/common-model/src/AP/AJS';
import { StorageOfUniqueServices } from '@qality/common-service';
import { Utils } from '@qality/common-utils';

import API from './API';

const DEFAULT_JIRA_ADMIN_SETTINGS = {
  isQalityForNewProjectsEnabled: true,
  isPluginForNewProjectsEnabled: true,
};

export default {
  async getJiraAdminSettings(): Promise<typeof DEFAULT_JIRA_ADMIN_SETTINGS> {
    const response = await API.request(
      StorageOfUniqueServices.get('APIConstants').URL_DATA_JIRA_ADMIN_SETTINGS
    );
    if (isNil(response) || Utils.isNilOrEmpty(response.body)) {
      return DEFAULT_JIRA_ADMIN_SETTINGS;
    }
    const value = JSON.parse(response.body);
    // old users don't have isPluginForNewProjectsEnabled
    // so we set default value - true
    value.isPluginForNewProjectsEnabled = !isNil(
      value.isPluginForNewProjectsEnabled
    )
      ? value.isPluginForNewProjectsEnabled
      : true;
    return value;
  },

  setJiraAdminSettings(
    jiraAdminSettings: Record<string, unknown>
  ): Promise<AJSResponse> {
    return API.noRetry(
      StorageOfUniqueServices.get('APIConstants').URL_DATA_JIRA_ADMIN_SETTINGS,
      {
        type: 'PUT',
        contentType: 'application/json',
        data: JSON.stringify(jiraAdminSettings),
      }
    );
  },
};
